import { searchInputClass } from '../../lib/ui'

type Props = {
  value: string
  onChange: (value: string) => void
  placeholder?: string
  'aria-label': string
}

export function SearchField({ value, onChange, placeholder, 'aria-label': ariaLabel }: Props) {
  return (
    <input
      type="search"
      className={searchInputClass}
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      aria-label={ariaLabel}
    />
  )
}
